// Built-ins
import { useState } from "react";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";

// Modules / Functions
import { Modal } from "react-bootstrap";
import axios from "axios";
import { Button } from "semantic-ui-react";
import Swal from "sweetalert2";

// Global Variables
import { headers } from "../../global_vars";

import { aircraftYearSelectOptions } from "../../data_management/aircraft/aircraft_preview_urls";

// Variables
window.Swal = Swal;

const CHANGE_YEAR = "https://groupplan.gr/api/data_management/change_aircraft_year/";

function ChangeYear(props) {
  const [show, setShow] = useState(false);
  const [year, setYear] = useState(() =>
    props.year !== null && props.year !== undefined && props.year !== ""
      ? Number(props.year)
      : new Date().getFullYear()
  );
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setYear(
      props.year !== null && props.year !== undefined && props.year !== ""
        ? Number(props.year)
        : new Date().getFullYear()
    );
    setShow(true);
  };
  const baseYearOptions = aircraftYearSelectOptions();
  const yearNum = Number(year);
  const yearOptions =
    !Number.isNaN(yearNum) && !baseYearOptions.includes(yearNum)
      ? [yearNum, ...baseYearOptions].sort((a, b) => b - a)
      : baseYearOptions;

  const update_Year = () => {
    axios({
      method: "post",
      url: CHANGE_YEAR,
      headers: headers,
      data: {
        aircraft_id: props.aircraft_id,
        year: Number(year),
      },
    })
      .then((res) => {
        props.update_state(res.data.aircraft);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  return (
    <>
      <FiEdit2
        title={"edit aircraft's year"}
        id={"edit_aircraft_name"}
        onClick={handleShow}
        className={"edit_icon"}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change year for {props.make}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <select
            className="form-control"
            onChange={(e) => {
              setYear(Number(e.target.value));
            }}
            value={year}
          >
            {yearOptions.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              update_Year();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeYear;
